import { toString } from 'lodash-es';
import { Observable } from 'rxjs';

export function mapLogoBlobToString(response: Blob): Observable<string> {
  return new Observable<string>((observer) => {
    // Check if response is a Blob before trying to read it
    if (!(response instanceof Blob)) {
      observer.error(new Error('Response is not a Blob'));
      return;
    }

    const reader = new FileReader();
    reader.onloadend = () => {
      // The response contains a string that is as well a base64 string so
      // we have to decode it as well to get access to the real image in base64.
      const [, base64String] = toString(reader.result).split('base64,');
      observer.next(atob(base64String));
      observer.complete();
    };
    reader.onerror = (error) => observer.error(error);
    reader.readAsDataURL(response);
  });
}
